import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'findPwd', ...(require('E:/git/xkdoms/oms_web/passport/src/models/findPwd.js').default) });
app.model({ namespace: 'index', ...(require('E:/git/xkdoms/oms_web/passport/src/models/index.js').default) });
app.model({ namespace: 'login', ...(require('E:/git/xkdoms/oms_web/passport/src/models/login.js').default) });
app.model({ namespace: 'register', ...(require('E:/git/xkdoms/oms_web/passport/src/models/register.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
